<template>
  <div class="flex flex-col border-b border-neutral-50">
    <button class="flex gap-3 text-left mb-3" type="button" @click="onSetCurrent(index)">
      <div class="block w-1 flex-grow">
        <slot name="button"></slot>
      </div>
      <span class="w-4">
        <i v-icon:arrow-down></i>
      </span>
    </button>
    <div class="grid items-start overflow-hidden transition-all duration-500" :class="index == context.current ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'">
      <div class="overflow-hidden">
        <div class="pb-3">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "VMapFilterAccordionItem",
    inject: ['context', 'onSetCurrent'],
    props: ['index'],
  }
</script>

<style lang="scss" scoped>

</style>